;
/*!
 * subitotexto.js - main JS file
 */
var SubitoTexto = {};

SubitoTexto.init = function () {
	var $ = jqPla,
		strPageId = $( 'body' ).attr( 'id' );

	SubitoTexto.menu.init();

	console.log("INIT strPageId", strPageId);

	switch ( strPageId ) {
		case 'home':
		// todo:  ajouter l'insert du concours <a l'index 2 du blogue (ou index 1 ou 0 si blogue vide)
		case 'author':
			SubitoTexto.article.init();
			break;
		case 'blogpost-single':
			SubitoTexto.comments.init();
			break;
		case 'concours_inscription':
			SubitoTexto.concours_inscription.init();
			break;
		case 'concours':
			SubitoTexto.concours.init();
			SubitoTexto.concoursVideos.init();
			break;

		case 'contestresults':
			SubitoTexto.contestResults.init();
			break;

	}


	SubitoTexto.blogPostLikes.init();

	SubitoTexto.form.init();

	SubitoTexto.videoTfo.init();
	SubitoTexto.videoTq.init();
	SubitoTexto.survey.init();
	SubitoTexto.fontSizeSwitcher.init();


	SubitoTexto.loadMorePosts.init();
	SubitoTexto.loadMoreComments.init();
	SubitoTexto.masonryInit.init();

	SubitoTexto.soumissionOu.init();


	SubitoTexto.courrierSubmit.init();
	SubitoTexto.courrierComments.init();

	SubitoTexto.submitArticle.init();

	SubitoTexto.expandingGrid.init();
	SubitoTexto.pointageTabs.init();

	SubitoTexto.kludges.init();

	PLA.a11y.addScreenReaderRevealButton.init();


	if ( $( '.ne-pas-toucher-btn' ).length > 0 ) {
		SubitoTexto.nepastoucheranimation.init();
		SubitoTexto.effects.init();
	}


	PLA.UTILS.disabledDisabledLinks();


};

// Immediate init

jqPla( function () {
	var $ = jqPla;

	if ( $( '.pc-group' ).length > 0 ) {
		$( '.pc-group' ).photocollantsSlider();
	}

	if ( $( 'body' ).hasClass( 'post-single' ) ) {
		var $container = $( '.article-title' ).find( 'span' );

		$( window ).on( 'resize', function () {
			SubitoTexto.splitText( $container );
		} );


		$( window ).trigger( 'resize' );
		setTimeout(function() {

		}, 2000);
	}

	SubitoTexto.init();

// FixedSticky.tests.sticky = false;
//$( '.fixed-sticky' ).fixedsticky();

	SubitoTexto.photocollantsMaker.init();


	var gifs = Gifffer();

	// Only auto play if not in TFO mode
	if ( $( 'html' ).attr( 'id' ) != 'mode-tfo' ) {
		setTimeout( function () {
			for ( var i = 0; i < gifs.length; i++ ) {
				gifs[ i ].click();
			}
		}, 1000 );
	}

} );